import { render, staticRenderFns } from "./eventApproval.vue?vue&type=template&id=c7a32b6c&scoped=true"
import script from "./eventApproval.vue?vue&type=script&lang=js"
export * from "./eventApproval.vue?vue&type=script&lang=js"
import style0 from "./eventApproval.vue?vue&type=style&index=0&id=c7a32b6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a32b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7a32b6c')) {
      api.createRecord('c7a32b6c', component.options)
    } else {
      api.reload('c7a32b6c', component.options)
    }
    module.hot.accept("./eventApproval.vue?vue&type=template&id=c7a32b6c&scoped=true", function () {
      api.rerender('c7a32b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/exceptionReporting/component/eventApproval.vue"
export default component.exports